import React , {useState , useContext , useEffect}from 'react'; 
import Context from '../../context/context';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { travelTypeEnum } from '../../common/enum';  
import { Link } from 'react-router-dom';

function Footer() {
    const { state } = useContext(Context);

    const phoneNumberSadir = "+972548700200";
    const phoneNumberPrivate = "+972548700200";
    const phoneTrains = "+9727322562700";
    const ukrainePhone = "+380933790111";

    const phoneNumber =
    (state?.tripType === travelTypeEnum.train)
    ? phoneTrains
    : (state?.tripType === travelTypeEnum.private)
    ? phoneNumberPrivate
    : phoneNumberSadir;

    function handleWhatsAppClick() {
      window.open(`https://wa.me/${phoneNumber}`, '_blank');
    }

    return (
      <div className='footerDiv' style={{height: '200px' , backgroundColor: '#e7e7e8'}}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , paddingTop: '50px' , marginTop: '10px'}}>
            <PhoneIcon sx={{ mr: 1, fontSize: 30 }} />
            {/* <WhatsAppIcon
              sx={{ color: '#25D366', mr: 1, fontSize: 30 , cursor: 'pointer' }}
              onClick={handleWhatsAppClick}
            /> */}
            {phoneNumber}
          </div>

          {/*ukraine number*/}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , marginTop: '10px'}}>
            <PhoneIcon sx={{ mr: 1, fontSize: 30 }} />
            <WhatsAppIcon
              sx={{ color: '#25D366', mr: 1, fontSize: 30 , cursor: 'pointer' }}
              onClick={handleWhatsAppClick}
            />
            {ukrainePhone}
          </div>

          {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , paddingTop: '10px' , marginTop: '10px'}}>
            <EmailIcon
              sx={{ color: 'red', mr: 1, fontSize: 30 , cursor: 'pointer', marginLeft: '10px' }}
            />
            PRH700262@gmail.com
          </div> */}
          
        </div>
         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , paddingTop: '10px' , marginTop: '10px'}}>
            <p style={{paddingRight : '10px'}}>
                        <a href="/AccessibilityStatement">הצהרת נגישות</a>
            </p>
            <p style={{paddingRight : '10px'}}>
              <a href="/PrivacyStatement">הצהרת פרטיות</a>
            </p>
            <p style={{paddingRight : '10px'}}>
            <Link to="/Terms">תנאי שימוש באתר</Link>
            </p>
          </div>
      </div>
    )
}

export default Footer;
